import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={20}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.30754 4.15385C4.92908 4.15385 4.61523 3.84 4.61523 3.46154V0.692308C4.61523 0.313846 4.92908 0 5.30754 0C5.686 0 5.99985 0.313846 5.99985 0.692308V3.46154C5.99985 3.84 5.686 4.15385 5.30754 4.15385Z"
      fill="#1F2A37"
    />
    <path
      d="M12.6923 4.15385C12.3138 4.15385 12 3.84 12 3.46154V0.692308C12 0.313846 12.3138 0 12.6923 0C13.0708 0 13.3846 0.313846 13.3846 0.692308V3.46154C13.3846 3.84 13.0708 4.15385 12.6923 4.15385Z"
      fill="#1F2A37"
    />
    <path
      d="M16.8465 7.92911H1.15422C0.77576 7.92911 0.461914 7.61526 0.461914 7.2368C0.461914 6.85834 0.77576 6.54449 1.15422 6.54449H16.8465C17.225 6.54449 17.5388 6.85834 17.5388 7.2368C17.5388 7.61526 17.225 7.92911 16.8465 7.92911Z"
      fill="#1F2A37"
    />
    <path
      d="M12.6923 19.8462H5.30769C1.93846 19.8462 0 17.9078 0 14.5386V6.6924C0 3.32317 1.93846 1.3847 5.30769 1.3847H12.6923C16.0615 1.3847 18 3.32317 18 6.6924V14.5386C18 17.9078 16.0615 19.8462 12.6923 19.8462ZM5.30769 2.76932C2.66769 2.76932 1.38462 4.0524 1.38462 6.6924V14.5386C1.38462 17.1786 2.66769 18.4616 5.30769 18.4616H12.6923C15.3323 18.4616 16.6154 17.1786 16.6154 14.5386V6.6924C16.6154 4.0524 15.3323 2.76932 12.6923 2.76932H5.30769Z"
      fill="#1F2A37"
    />
  </svg>
);

export default SVGComponent;
